import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lima_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Unverified accounts get a friendly prompt instead of a bare error toast.
// The caller's own catch block still runs, so its duplicate toast is cleared
// once the modal has taken over the message.
api.interceptors.response.use(undefined, (error) => {
  if (error.response?.headers?.["x-email-verification-required"]) {
    window.dispatchEvent(new CustomEvent("limya:email-verification-required"));
    setTimeout(() => toast.dismiss(), 0);
    setTimeout(() => toast.dismiss(), 250);
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
